/* eslint-disable no-nested-ternary */
import React from 'react';
import LayoutComponent from '../../components/home/layouts/LayoutComponent';
import AllCoursesList from '../../components/course-list/all-courses-list';

function Courses() {
  return (
    <div>
      <LayoutComponent pageName="allCourses">
        <AllCoursesList />
      </LayoutComponent>
    </div>
  );
}

export default Courses;
